import { registerAction } from '../../../Action'

const LOAD_CONTENT_PUBLISH_STATUS = 'LOAD_CONTENT_PUBLISH_STATUS'

const spliceInContentPublishStatus = (currentContent, newContentPiece) => {
  const index = currentContent.findIndex(
    (content) => content.id === newContentPiece.id
  )
  if (index > -1) {
    return currentContent.splice(index, 1, newContentPiece)
  }
  return [...currentContent, newContentPiece]
}

const reducer = (state = {}, action) => ({
  ...state,
  publish_statuses: spliceInContentPublishStatus(
    state.publish_statuses || [],
    action.payload
  ),
})

const loadContentPublishStatus = registerAction(LOAD_CONTENT_PUBLISH_STATUS, {
  reducer,
})

export default loadContentPublishStatus
